<template>
  <div class="modal fade" :class="{ show: isShow }" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" :class="modalCls" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot name="title"></slot>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <div>
            <slot name="save-button"></slot>
          </div>
          <div>
            <button type="button" class="btn btn-sm btn-secondary" @click="hide()" data-dismiss="modal">
              <span aria-hidden="true" class="glyphicon glyphicon-remove"></span> Đóng
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VAModal',
  data () {
    return {
      isShow: false,
    }
  },
  props: {
    'modalCls': {
      type: String,
      default: 'modal-sm'
    },
  },
  mounted () {
    this.clickOutside()
  },
  methods: {
    show () {
      this.isShow = true
    },
    toggle () {
      this.isShow = !this.isShow
    },
    hide () {
      this.isShow = false
    },
    clickOutside () {
      const vm = this
      window.addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) {
          vm.hide()
        }
      })

      window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          vm.hide()
        }
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/VAModal.vue